module.exports = __webpack_public_path__ + "static/media/Servicio_torres.ccaca9c5.jpg";